export default {
  message: 'Only candidates that are engaged in the positions you follow are shown here',
  searchResultMsg: `Sorry, we haven't found any results matching this search.`,
  positionWiseSearch: `Filter a position`,
};
